import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";
import { KindOfOrder } from "../../../../types/enums";

export const useMarkCFINoteAsRead = (
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async (params: { noteID?: number, orderID?: number, kindOfOrder?: KindOfOrder }) => {
			return await apiClient.post("note/mark-cfi-note-as-read", {
				noteID: params.noteID,
				orderID: params.orderID,
				kindOfOrder: params.kindOfOrder
			}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when marking note as read: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
